import type { Entitlements } from '../../types';
import {
  CLIENT_CORRELATION_ID_HEADER,
  generateClientCorrelationId,
} from '../../utils/correlationId';
import { isLocalEnvironment } from '../../utils/environment';
import { axiosClient } from '../client/AxiosClient';

export const fetchEntitlementsData = async (): Promise<Entitlements> => {
  // If running locally, use the local Express server
  // throw new Error('simulated error for testing');
  const config = {
    headers: { [CLIENT_CORRELATION_ID_HEADER]: generateClientCorrelationId() },
  };

  if (isLocalEnvironment()) {
    const { data } = await axiosClient.get<Entitlements>(
      'http://localhost:3001/internal-operations/software-distribution/entitlements',
      config,
    );

    return data;
  }
  // Otherwise use the axios client for remote environments
  const { data } = await axiosClient.get<Entitlements>(
    '/internal-operations/software-distribution/entitlements',
    config,
  );

  return data;
};
